module.exports = __webpack_public_path__ + "static/media/option-3.9f6d09db.ogg";